import * as TK from 'components/Header/Menus/translations/header-menus.locale.constants';

export const headerMenusCommonLocale = {
  [TK.LOCALE_ENGLISH]: 'English',
  [TK.LOCALE_FRENCH]: 'Français',
  [TK.SIGNUP_LOGIN_ARIA_LABEL]: 'Sign Up or Log In to your Edible Account',
};
